import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as tvCategoryModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='live_channel_category' />
}

const skin = era.skin('routes/tv/category')

TVCategoryPage.displayName = 'TVCategoryPage'
export function TVCategoryPage(): JSX.Element {
  const isContentLoading = useUnit(tvCategoryModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='tvCategory' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
